/*
 * @Author: your name
 * @Date: 2022-03-27 16:56:13
 * @LastEditTime: 2022-04-30 22:52:50
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\mixins\form.js
 */

export const formMixins = {
    data() {
        return {
           form: {},
           errors: {},
           rules: [],
           scrollTag: '', // 滚动到标签的位置 ref
           isFirst: true,
        }
    },
    computed: {
        validateForm() {
            return function(formData) {
                console.log(formData)
                this.isFirst = true
             
                var result = true
                let validateRules = this.rules
                if(!validateRules || validateRules.length == 0) return result
                Object.keys(formData).forEach(key=> {
            
                    let errorMessage = ""

                    let rule = validateRules.find(e=> e.name == key)
                    if(!rule || !rule.validate || rule.validate.length == 0) return true

                    let value = formData[key]
                    rule.validate.forEach((item, index)=> {
                        if(errorMessage) return ;
                        if(item["require"]) {
                            // console.log(item)
                            if(!value || (typeof(value) == 'object' && value.length == 0))
                            {
                                // || value.replace(/\s*/g).length == 0
                                errorMessage = item['message'] 
                                // console.log('44')
                                console.log(45)
                                if(document.getElementById(key)){
                                    result = false
                                }
                               
                            }
                        }
                        if(item["regExp"]) {
                            if(!item["regExp"].test(value))
                            {
                                errorMessage = item['message'] 
                                console.log('51')
                                result = false
                            }
                        }
                    })
                    if(this.isFirst && errorMessage) {
                        this.scrollTag = key
                        this.isFirst = false
                    }
                    this.$set(this.errors, key, errorMessage)
                })
                const requireItem =   document.getElementsByClassName('require-item')
                Array.from(requireItem).forEach(item=>{
                    if(!item.value){
                        console.log(item.id,'????')
                        let id = item.id.replace('require-','')
                         this.$set(this.errors, id, item.getAttribute('data-placeholder'))
                         this.scrollTag = id
                         result = false
                    }
                })

                const requireRadio =   document.getElementsByClassName('require-radio')
                Array.from(requireRadio).forEach(item=>{
                    console.log(item.getAttribute('data-value'))
                    // if(!item.value){
                    //     console.log(item.id,'????')
                    //     let id = item.id.replace('require-','')
                    //      this.$set(this.errors, id, '请填写')
                    //      this.scrollTag = id
                    //      result = false
                    // }
                })
                console.log(result)
                return result
            }
        }
    },
    methods: {
        clearErrors() {
            let errors = this.errors
            Object.keys(errors).forEach(key=> {
                this.$set(this.errors, key, "")
            })
        },
        removeError(fieldName) {
            this.$set(this.errors, fieldName, "")
        },
        /**
         * 输入框（表单）变更-移除error信息（自定义的验证，需要在onBlur失去焦点事件处理,暂未出处理）
         */
        onChange(value, fieldName) {
        console.log('onChange')
            if(this.errors[fieldName]) {
                this.errors[fieldName] = ''
            }
        },
    }
}